import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { GlobalService } from '../../../../SGRE-shared/services/global.service';
import { ApiService } from '../../../../SGRE-shared/services/api.service';
import { LoggerService, tryNormalizeHttpError } from '@spartacus/core';
import { OrderHistoryActions } from '../actions/index';
import { OrderHistoryEffectService } from './order-history-effect.service';

@Injectable()
export class orderHistoryChartsEffects {
  constructor(
    private actions$: Actions,
    private globalService: GlobalService,
    private apiService: ApiService,
    private orderHistoryService: OrderHistoryEffectService
  ) {}

  protected logger = inject(LoggerService);

    salesCharts$: Observable<
        ReturnType<typeof OrderHistoryActions.loadSalesChartsSuccess> |
        ReturnType<typeof OrderHistoryActions.loadSalesChartsFailure>
    > = createEffect(() =>
        this.actions$.pipe(
            ofType(OrderHistoryActions.loadSalesCharts),
            switchMap((action) => {
                this.globalService.loadingSubject.next(true);
                return this.apiService.getPowerBi(action.param).pipe(
                    map((data: any) => {
                        this.globalService.loadingSubject.next(false);
                        return OrderHistoryActions.loadSalesChartsSuccess(
                            { payload: this.orderHistoryService.createChartsConfig(data) });
                    }),
                    catchError((error) => {
                        this.globalService.loadingSubject.next(false);
                        return of(OrderHistoryActions.loadSalesChartsFailure({ payload: tryNormalizeHttpError(error, this.logger) }));
                    })
                );
            })
        )
    );

    soldSales$: Observable<
        ReturnType<typeof OrderHistoryActions.loadSoldSalesSuccess> |
        ReturnType<typeof OrderHistoryActions.loadSoldSalesFailure>
    > = createEffect(() =>
        this.actions$.pipe(
            ofType(OrderHistoryActions.loadSoldSales),
            switchMap((action) => {
                this.globalService.loadingSubject.next(true);
                return this.apiService.getPowerBi(action.param)
                    .pipe(
                        map((data: any) => {
                            this.globalService.loadingSubject.next(false);
                            return OrderHistoryActions.loadSoldSalesSuccess(
                                { payload: this.orderHistoryService.createChartsConfig(data) });
                        }),
                        catchError((error) => {
                            this.globalService.loadingSubject.next(false);
                            return of(OrderHistoryActions.loadSoldSalesFailure({ payload: tryNormalizeHttpError(error, this.logger) }));
                        })
                    );
            })
        )
    );

    customerWiseSales$: Observable<
        ReturnType<typeof OrderHistoryActions.loadCustomerWiseSalesSuccess> |
        ReturnType<typeof OrderHistoryActions.loadCustomerWiseSalesFailure>
    > = createEffect(() =>
        this.actions$.pipe(
            ofType(OrderHistoryActions.loadCustomerWiseSales),
            switchMap((action) => {
                this.globalService.loadingSubject.next(true);
                return this.apiService.getPowerBi(action.param)
                    .pipe(
                        map((data: any) => {
                            this.globalService.loadingSubject.next(false);
                            return OrderHistoryActions.loadCustomerWiseSalesSuccess(
                                { payload: this.orderHistoryService.createChartsConfig(data) });
                        }),
                        catchError((error) => {
                            this.globalService.loadingSubject.next(false);
                            return of(OrderHistoryActions.loadCustomerWiseSalesFailure({ payload: tryNormalizeHttpError(error, this.logger) }));
                        })
                    );
            })
        )
    );

    legalEntityWiseSales$: Observable<
        ReturnType<typeof OrderHistoryActions.loadLegalEntityWiseSalesSuccess> |
        ReturnType<typeof OrderHistoryActions.loadLegalEntityWiseSalesFailure>
    > = createEffect(() =>
        this.actions$.pipe(
            ofType(OrderHistoryActions.loadLegalEntityWiseSales),
            switchMap((action) => {
                this.globalService.loadingSubject.next(true);
                return this.apiService.getPowerBi(action.param)
                    .pipe(
                        map((data: any) => {
                            this.globalService.loadingSubject.next(false);
                            return OrderHistoryActions.loadLegalEntityWiseSalesSuccess(
                                { payload: this.orderHistoryService.createChartsConfig(data) });
                        }),
                        catchError((error) => {
                            this.globalService.loadingSubject.next(false);
                            return of(OrderHistoryActions.loadLegalEntityWiseSalesFailure({ payload: tryNormalizeHttpError(error, this.logger) }));
                        })
                    );
            })
        )
    );
}
